// src/pages/AcceptInvitePage.js
import React, { useEffect, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

function safeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  const token = useMemo(() => safeString(params.get("token")).trim(), [params]);
  const email = useMemo(() => safeString(params.get("email")).trim(), [params]);

  useEffect(() => {
    if (!token) return;

    const next = `/reset-password?token=${encodeURIComponent(token)}${
      email ? `&email=${encodeURIComponent(email)}` : ""
    }`;

    nav(next, { replace: true });
  }, [token, email, nav]);

  return (
    <div style={{ maxWidth: 560, margin: "40px auto", padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>Invite link updated</h2>

      <p style={{ marginTop: 0, color: "#555" }}>
        Flowtrak now uses a direct password setup flow for invited users.
      </p>

      {token ? (
        <div
          style={{
            padding: 12,
            borderRadius: 10,
            background: "#eff6ff",
            color: "#1e3a8a",
            border: "1px solid #bfdbfe",
            marginTop: 16,
          }}
        >
          Redirecting you to password setup…
        </div>
      ) : (
        <div
          style={{
            padding: 12,
            borderRadius: 10,
            background: "#fee2e2",
            color: "#991b1b",
            marginTop: 16,
          }}
        >
          This invite link is missing required information or is no longer valid.
          <div style={{ marginTop: 8 }}>
            Please request a new invite from your manager or return to the login page.
          </div>
          <div style={{ marginTop: 12 }}>
            <Link to="/login">Go to login</Link>
          </div>
        </div>
      )}
    </div>
  );
}